import { SubscriptionsApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const subscriptionsApi = SubscriptionsApi({}, '/api', axiosInstance);
